import type { Except } from "type-fest";
import type { IsoAndUnixTimestamp} from "../date-time/iso-and-unix";
import { nowIsoAndUnix } from "../date-time/iso-and-unix";
import type { StorageItem } from "./storage-item";
import type { StorageItemId } from "./storage-item-id";

type StorageItemUpload = {
    _id: StorageItemId;
    _createdAt: IsoAndUnixTimestamp;
    _type: "STORAGE_ITEM_UPLOAD";
    storageItem: StorageItem;
};

type StorageItemUploadFactoryParams = Except<
    StorageItemUpload,
    "_type" | "_createdAt" | "_id"
>;
const storageItemUploadFactory = (
    params: StorageItemUploadFactoryParams,
): StorageItemUpload => {
    return {
        _id: params.storageItem._id,
        _createdAt: nowIsoAndUnix(),
        _type: "STORAGE_ITEM_UPLOAD",
        ...params,
    };
};

export { storageItemUploadFactory };
export type { StorageItemUpload };
